import React from 'react';
import { 
  Box, 
  Typography, 
  Paper,
  Avatar,
  Chip,
  Stack
} from '@mui/material';

/**
 * Gets initials from a person's name
 * @param {string} firstName - First name
 * @param {string} lastName - Last name
 * @returns {string} - Initials (up to 2 characters)
 */
const getInitials = (firstName, lastName) => {
  const firstInitial = firstName ? firstName[0] : '';
  const lastInitial = lastName ? lastName[0] : '';
  return `${firstInitial}${lastInitial}`.toUpperCase();
};

/**
 * Displays list of registered participants for the session in a compact format
 * 
 * @param {Object} props
 * @param {Array} props.participants - List of registered participants
 */
const ParticipantsList = ({ participants }) => {
  return (
    <Paper elevation={3} sx={{ p: 4 }}>
      <Typography variant="h3" gutterBottom sx={{ fontSize: '2.5rem', mb: 3 }}>
        Geregistreerde deelnemers ({participants.length})
      </Typography>
      
      {participants.length === 0 ? (
        <Typography variant="body1" sx={{ textAlign: 'center', py: 3, fontSize: '1.8rem' }}>
          Er zijn nog geen deelnemers geregistreerd voor deze sessie.
        </Typography>
      ) : (
        <Box sx={{ 
          display: 'flex', 
          flexWrap: 'wrap', 
          gap: 1.5, 
          maxHeight: '300px', 
          overflowY: 'auto',
          py: 1.5
        }}>
          {participants.map((user, index) => {
            const initials = getInitials(user.first_name, user.last_name);
            return (
              <Chip
                key={user.id || index}
                label={user.alias || `${initials}`}
                variant="outlined"
                sx={{ 
                  m: 0.8,
                  height: 'auto',
                  py: 1,
                  '& .MuiChip-label': {
                    maxWidth: '150px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: '1.4rem',
                    px: 1.5
                  }
                }}
              />
            );
          })}
        </Box>
      )}
    </Paper>
  );
};

export default ParticipantsList;